module.exports = __webpack_public_path__ + "static/img/banner1.6b0eb009.png";